import { JSX } from 'react';
import { TextField } from '@mui/material';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export default function EmailInput({ value, onChange }: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ inputMode: 'email', 'data-testid': 'email-input' }}
      placeholder="email@example.com"
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
